
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autori",
      function () {
        return require("private-next-pages/autori/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autori"])
      });
    }
  